/**
 * Проверяет, что публичное имя относится к общей гостевой учетной записи.
 *
 * @param {string} name Публичное имя пользователя из сервера.
 * @returns {boolean} `true`, если имя нужно заменить локализованным названием гостя.
 */
export function isGuestPublicName(name) {
  return name === 'Гость' || name === 'Guest';
}

/**
 * Возвращает локализованное публичное имя пользователя.
 *
 * @param {string} name Публичное имя пользователя из сервера.
 * @param {Function} formatMessage Функция `react-intl` для получения перевода.
 * @param {object} guestMessage Описание сообщения `react-intl` для имени гостя.
 * @returns {string} Локализованное имя гостя или исходное имя пользователя.
 */
export function localizedPublicName(name, formatMessage, guestMessage) {
  return isGuestPublicName(name) ? formatMessage(guestMessage) : name;
}
